/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { flatten } from 'lodash';

/**
 * Base font size in pixels - rem default is 16px
 * @type {Number}
 */
const remBasePixels = 16;

/**
 * Value that can either be a number or a string
 * representing a CSS value.
 * @type {CSSValue}
 */

/**
 * Converts units supplied via the rest parameter to `rem` values
 * based on the suppled base value.
 * Based off Foundation Sass function - a proprietary framework
 * @see: https://gist.github.com/kylewebdev/f36acbfd2e9257d88253
 * @param  {number}     baseValue    base font size to use for rem calculation
 * @param  {CSSValue[]} ...valueList CSS units as comma seperated or space seperated entities
 * @return {string}                  the rem conversion string to use as a CSS value
 * @function
 */
export const remCalcCustomBase = function () {
  let baseValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : remBasePixels;
  for (var _len = arguments.length, valueList = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    valueList[_key - 1] = arguments[_key];
  }
  return flatten(valueList.map(values => {
    const valueString = typeof values === 'number' ? values.toString() : values;
    return valueString.split(' ');
  })).map(value => {
    // strip unit from value if supplied
    const remString = value.replace('px', '');
    // convert to rem units
    const remValue = Number.parseInt(remString, 10) / baseValue;
    // return the string with rem appended
    return `${remValue}rem`;
  }).join(' ');
};

/**
 * Converts units supplied via the rest parameter to `rem` values based on default base font size
 * @param  {CSSValue[]} ...valueList CSS units as comma seperated or space seperated entities
 * @return {string}                  the rem conversion string to use as a CSS value
 * @function
 */
export const remCalc = function () {
  for (var _len2 = arguments.length, valueList = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    valueList[_key2] = arguments[_key2];
  }
  return remCalcCustomBase(remBasePixels, ...valueList);
};